import React, { useEffect, useState } from "react";
import { toast } from "sonner";
import { useGlobalContext } from "../../GlobalContext";
import axios from "axios";
import {
  UserIcon,
  UserCheckIcon,
  ImageIcon,
  Upload,
} from "lucide-react";
import useShop from "../../Sevices/useShop";
import useCreateTask from "../../Sevices/useCreateTask";
import RestaurantDropdown from "../Utils/RestaurantDropdown";

const initialTaskData = {
  orderId: "",
  dailyOrderId: "",
  userType: "admin",
  restaurantId: "",
  taskDescription: "",
  taskType: "",
  restaurantNumber: "",
  restaurantEmail: "",
  customerName: "",
  customerMobile: "",
  deliveryDate: "",
  deliveryAddress: "",
  deliveryLatitude: "",
  deliveryLongitude: "",
  pickupAddress: "",
  pickupLatitude: "",
  pickupLongitude: "",
  vehicle: "",
  paymentMethod: "",
  trackId: "",
  senderInfo: {
    mobile: "",
    fullName: "",
    email: "",
    address: "",
  },
  receiverInfo: {
    mobile: "",
    fullName: "",
    email: "",
    address: "",
  },
  taskImages: [],
};

const initialItem = {
  itemName: "",
  itemType: "",
  itemDescription: "",
  width: "",
  height: "",
  length: "",
  weight: "",
};

const AddTaskModal = ({ isOpen, onClose, shops = [] }) => {
  const [formData, setFormData] = useState(initialTaskData);
  const [deliveryItems, setDeliveryItems] = useState([initialItem]);
  const [taskImages, setTaskImages] = useState([]);

  const { createTask, isSubmitting } = useCreateTask();

  const handleChange = (e) => {
    setFormData((prev) => ({ ...prev, [e.target.name]: e.target.value }));
  };
  const handleItemChange = (index, e) => {
    const updatedItems = [...deliveryItems];
    updatedItems[index][e.target.name] = e.target.value;
    setDeliveryItems(updatedItems);
  };
  const handleImageUpload = (e) => {
    const files = Array.from(e.target.files).slice(0, 5 - taskImages.length);
    const promises = files.map((file) => {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result);
        reader.onerror = reject;
      });
    });
    Promise.all(promises)
      .then((base64s) => setTaskImages((prev) => [...prev, ...base64s]))
      .catch(() => toast.error("Image upload failed"));
  };

  const removeImage = (index) => {
    setTaskImages((prev) => prev.filter((_, i) => i !== index));
  };

  const addItem = () => setDeliveryItems([...deliveryItems, initialItem]);

  const removeItem = (index) => {
    const updatedItems = deliveryItems.filter((_, i) => i !== index);
    setDeliveryItems(updatedItems);
  };

  const handleSenderChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      senderInfo: {
        ...prev.senderInfo,
        [name]: value,
      },
    }));
  };
  // Tailwind utility for all inputs
  const inputStyled =
    "w-full border px-3 py-2 rounded shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-400";

  const handleReceiverChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({
      ...prev,
      receiverInfo: {
        ...prev.receiverInfo,
        [name]: value,
      },
    }));
  };

  useEffect(() => {
    console.log("AddTaskModal shops:", shops);
  }, [shops]);

  const handleSubmit = async () => {
    const success = await createTask(formData, deliveryItems, taskImages);

    if (success) {
      setFormData(initialTaskData);
      setDeliveryItems([initialItem]);
      setTaskImages([]);
      onClose();
    }
  };

  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50"
      onClick={onClose}
    >
      <div
        className="bg-white w-full max-w-3xl max-h-[90vh] overflow-y-auto rounded-xl shadow-lg p-6"
        onClick={(e) => e.stopPropagation()}
      >
        <h2 className="text-xl font-semibold mb-4">Add New Task</h2>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-sm font-medium mb-1">Order ID</label>
            <input
              name="orderId"
              value={formData.orderId}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Restaurant</label>
            <RestaurantDropdown
              restaurants={(shops || []).map((shop) => ({
                restaurantId: shop.shop_code,
                restaurantName: shop.shop_name,
              }))}
              value={formData.restaurantId}
              onChange={(restaurantId) =>
                handleChange({
                  target: {
                    name: "restaurantId",
                    value: restaurantId,
                  },
                })
              }
              placeholder="Select Restaurant"
              className="w-full"
              dropdownHeight="max-h-[220px]"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Task Description
            </label>
            <input
              name="taskDescription"
              value={formData.taskDescription}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">Task Type</label>
            <input
              name="taskType"
              value={formData.taskType}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Restaurant Number
            </label>
            <input
              name="restaurantNumber"
              value={formData.restaurantNumber}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Restaurant Email
            </label>
            <input
              name="restaurantEmail"
              value={formData.restaurantEmail}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Customer Name
            </label>
            <input
              name="customerName"
              value={formData.customerName}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Customer Mobile
            </label>
            <input
              name="customerMobile"
              value={formData.customerMobile}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div>
            <label className="block text-sm font-medium mb-1">
              Delivery Date
            </label>
            <input
              type="date"
              name="deliveryDate"
              value={formData.deliveryDate}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>

          <div className="sm:col-span-2">
            <label className="block text-sm font-medium mb-1">
              Delivery Address
            </label>
            <input
              name="deliveryAddress"
              value={formData.deliveryAddress}
              onChange={handleChange}
              className="w-full border px-3 py-2 rounded"
            />
          </div>
        </div>
        <div className="mt-6 p-4 rounded-md bg-blue-50 border border-blue-200 shadow-sm">
          <h3 className="text-md font-semibold text-blue-700 mb-3 flex items-center gap-2">
            <UserIcon className="w-4 h-4" /> Sender Information
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              name="fullName"
              value={formData.senderInfo.fullName}
              onChange={handleSenderChange}
              placeholder="Full Name"
              className={inputStyled}
            />
            <input
              name="mobile"
              value={formData.senderInfo.mobile}
              onChange={handleSenderChange}
              placeholder="Mobile Number"
              className={inputStyled}
            />
            <input
              name="email"
              value={formData.senderInfo.email}
              onChange={handleSenderChange}
              placeholder="Email Address"
              className={inputStyled}
            />
            <input
              name="address"
              value={formData.senderInfo.address}
              onChange={handleSenderChange}
              placeholder="Full Address"
              className={`${inputStyled} col-span-2`}
            />
          </div>
        </div>

        <div className="mt-6 p-4 rounded-md bg-green-50 border border-green-200 shadow-sm">
          <h3 className="text-md font-semibold text-green-700 mb-3 flex items-center gap-2">
            <UserCheckIcon className="w-4 h-4" /> Receiver Information
          </h3>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            <input
              name="fullName"
              value={formData.receiverInfo.fullName}
              onChange={handleReceiverChange}
              placeholder="Full Name"
              className={inputStyled}
            />
            <input
              name="mobile"
              value={formData.receiverInfo.mobile}
              onChange={handleReceiverChange}
              placeholder="Mobile Number"
              className={inputStyled}
            />
            <input
              name="email"
              value={formData.receiverInfo.email}
              onChange={handleReceiverChange}
              placeholder="Email Address"
              className={inputStyled}
            />
            <input
              name="address"
              value={formData.receiverInfo.address}
              onChange={handleReceiverChange}
              placeholder="Full Address"
              className={`${inputStyled} col-span-2`}
            />
          </div>
        </div>

        <div className="mt-6">
          <label className="block text-sm font-medium mb-2 flex items-center gap-2 text-gray-700">
            <ImageIcon className="w-4 h-4 text-blue-600" />
            Upload Task Images (Max 5)
          </label>

          <div className="relative w-full">
            <input
              id="image-upload"
              type="file"
              multiple
              accept="image/*"
              onChange={handleImageUpload}
              className="hidden"
              disabled={taskImages.length >= 5}
            />
            <label
              htmlFor="image-upload"
              className={`inline-flex items-center gap-2 px-4 py-2 bg-blue-600 text-white text-sm font-medium rounded shadow hover:bg-blue-700 transition duration-200 cursor-pointer ${
                taskImages.length >= 5 ? "opacity-50 cursor-not-allowed" : ""
              }`}
            >
              <Upload className="w-4 h-4" />
              Choose Images
            </label>
          </div>

          {taskImages.length > 0 && (
            <div className="flex flex-wrap gap-3 mt-4">
              {taskImages.map((img, index) => (
                <div key={index} className="relative group">
                  <img
                    src={img}
                    className="w-24 h-24 object-cover border rounded-md shadow-sm"
                    alt={`task-image-${index}`}
                  />
                  <button
                    type="button"
                    onClick={() => removeImage(index)}
                    className="absolute top-0 right-0 bg-red-600 text-white rounded-full w-5 h-5 flex items-center justify-center text-xs shadow group-hover:scale-110 transition"
                    title="Remove"
                  >
                    ✕
                  </button>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 gap-6 mt-6">
          {/* Pickup Address */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Pickup Address
            </label>
            <input
              name="pickupAddress"
              value={formData.pickupAddress}
              onChange={handleChange}
              placeholder="Enter pickup location"
              className="w-full border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Tracking ID */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Tracking ID
            </label>
            <input
              name="trackId"
              value={formData.trackId}
              onChange={handleChange}
              placeholder="Enter tracking ID"
              className="w-full border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            />
          </div>

          {/* Vehicle Type */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Vehicle Type
            </label>
            <select
              name="vehicle"
              value={formData.vehicle}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Vehicle</option>
              <option value="bike">Bike</option>
              <option value="scooter">Scooter</option>
              <option value="car">Car</option>
              <option value="van">Van</option>
            </select>
          </div>

          {/* Payment Method */}
          <div>
            <label className="block text-sm font-medium text-gray-700 mb-1">
              Payment Method
            </label>
            <select
              name="paymentMethod"
              value={formData.paymentMethod}
              onChange={handleChange}
              className="w-full border border-gray-300 px-3 py-2 rounded-md shadow-sm focus:outline-none focus:ring-2 focus:ring-blue-500"
            >
              <option value="">Select Payment Method</option>
              <option value="cash">Cash</option>
              <option value="upi">UPI</option>
              <option value="card">Card</option>
              <option value="cod">Cash on Delivery</option>
            </select>
          </div>
        </div>

        <div className="mt-6">
          <h3 className="text-md font-semibold mb-2">Delivery Items</h3>
          {deliveryItems.map((item, index) => (
            <div
              key={index}
              className="border rounded p-3 pt-8 mb-3 bg-gray-50 space-y-2 relative animate-pop"
            >
              <p className="font-bold text-l">Item {index + 1} </p>
              <button
                onClick={() => removeItem(index)}
                className="absolute right-2 top-2 text-sm text-red-500 hover:text-red-700"
                title="Remove Item"
              >
                ✕
              </button>
              <div className="grid grid-cols-1 sm:grid-cols-2 gap-2">
                <input
                  name="itemName"
                  value={item.itemName}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Item Name"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="itemType"
                  value={item.itemType}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Item Type"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="itemDescription"
                  value={item.itemDescription}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Item Description"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="width"
                  value={item.width}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Width"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="height"
                  value={item.height}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Height"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="length"
                  value={item.length}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Length"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
                <input
                  name="weight"
                  value={item.weight}
                  onChange={(e) => handleItemChange(index, e)}
                  placeholder="Weight"
                  className="border px-2 py-1 text-sm rounded w-full"
                />
              </div>
            </div>
          ))}

          <button
            onClick={addItem}
            className="mt-2 px-3 py-1 bg-blue-600 text-white text-sm rounded hover:bg-blue-700"
          >
            + Add Another Item
          </button>
        </div>

        <div className="mt-6 flex justify-end gap-3">
          <button
            onClick={onClose}
            disabled={isSubmitting}
            className="px-4 py-2 bg-gray-200 text-gray-700 rounded-md hover:bg-gray-300"
          >
            Cancel
          </button>
          <button
            onClick={handleSubmit}
            disabled={isSubmitting}
            className="px-4 py-2 bg-green-600 text-white rounded-md hover:bg-green-700"
          >
            {isSubmitting ? "Saving..." : "Add Task"}
          </button>
        </div>
      </div>
    </div>
  );
};

export default AddTaskModal;
